import designTokens from '@sohohouse/design-system/dist/tokens/tokens.json'
import lazySizes from 'lazysizes'
import 'lazysizes/plugins/blur-up/ls.blur-up'
import 'lazysizes/plugins/aspectratio/ls.aspectratio'
import 'lazysizes/plugins/attrchange/ls.attrchange'
import 'lazysizes/plugins/respimg/ls.respimg'

lazySizes.cfg.lazyClass = 'lazy'
lazySizes.customMedia = {
  '--mobile-sm': `(max-width: ${designTokens['media-query-mobile-sm']})`,
  '--mobile': `(max-width: ${designTokens['media-query-mobile']})`,
  '--tablet': `(max-width: ${designTokens['media-query-tablet']})`,
  '--desktop': `(max-width: ${designTokens['media-query-desktop']})`,
  '--wide': `(max-width: ${designTokens['media-query-wide']})`
}
lazySizes.expFactor = 1.5
lazySizes.hFac = 1
lazySizes.loadMode = 3

export default () => {
  if (process.client) {
    // Support background images
    document.addEventListener('lazybeforeunveil', e => {
      const bg = e.target.getAttribute('data-bg')
      if (bg) {
        e.target.style.backgroundImage = `url(${bg})`
      }
    })
  }
}
